// src/services/analysisService.js
import api from '../api/apiClient';

export const analysisService = {
  // Get all analyses
  async getAnalyses(filters = {}) {
    try {
      return await api.get('/analyses', filters);
    } catch (error) {
      console.error('Get analyses API error:', error);
      throw error;
    }
  },

  // Get analysis by ID
  async getAnalysis(id) {
    try {
      return await api.get(`/analyses/${id}`);
    } catch (error) {
      console.error('Get analysis API error:', error);
      throw error;
    }
  },

  // Create new analysis
  async createAnalysis(analysisData) {
    try {
      return await api.post('/analyses', analysisData);
    } catch (error) {
      console.error('Create analysis API error:', error);
      throw error;
    }
  },

  // Update analysis
  async updateAnalysis(id, analysisData) {
    try {
      return await api.put(`/analyses/${id}`, analysisData);
    } catch (error) {
      console.error('Update analysis API error:', error);
      throw error;
    }
  },

  // Delete analysis
  async deleteAnalysis(id) {
    try {
      return await api.delete(`/analyses/${id}`);
    } catch (error) {
      console.error('Delete analysis API error:', error);
      throw error;
    }
  },

  // Get analyses for current user's company
  async getCompanyAnalyses() {
    try {
      return await api.get('/analyses/company');
    } catch (error) {
      console.error('Get company analyses API error:', error);
      throw error;
    }
  },

  // Get analysis statistics
  async getAnalysisStats() {
    try {
      return await api.get('/analyses/stats');
    } catch (error) {
      console.error('Get analysis stats API error:', error);
      throw error;
    }
  }
};